/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Pxk_Items_EmptyInputs */

const vi_orders_pxk_items_empty = /** @type {(inputs: Orders_Pxk_Items_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phiếu xuất kho chưa có dòng hàng nào.`)
};

/**

* @param {Orders_Pxk_Items_EmptyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const orders_pxk_items_empty = /** @type {((inputs?: Orders_Pxk_Items_EmptyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Pxk_Items_EmptyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_orders_pxk_items_empty(inputs)
});